<template>
  <div class="limiter">
    <v-app-bar color="#1565C0" app elevation="0" height="70px" width="100%" flat>
      <v-row align="center" justify="center">
        <v-col cols="12" class="text-center">
          <img src="../../assets/logoConsumerBranca.png" alt="Logo do AIConsumer" class="logo-img" width="180">
      </v-col>
      </v-row>
    </v-app-bar>

    <div class="container-login100">
      <div class="wrap-login100">
        <v-container fluid>
          <v-row align="center" justify="center">
            <v-card
              class="login100-form"
              color="#FFFF"
              flat
              style="border-radius: 5px"
              rounded="lg"
              elevation="3"
            >
              <v-card-text v-if="exibeFormulario">
                <v-row dense justify="center">
                  <v-col cols="10">
                    <div v-if="errors.has('foto')">
                      <v-alert type="error" dense>{{ errors.first('foto') }}</v-alert>
                    </div>

                    <input
                      type="hidden"
                      v-model="consumidor.hashBase64"
                      v-validate="'required'"
                      data-vv-name="foto"
                    >

                    <div v-if="consumidor.hashBase64" class="text-center mb-4">
                      <v-avatar size="120" class="elevation-2">
                        <v-img :src="consumidor.hashBase64" alt="Foto do aluno"></v-img>
                      </v-avatar>
                      <div class="mt-2">
                        <v-btn small text color="primary" @click="dialogoCamera = true">
                          <v-icon small left>mdi-camera</v-icon>
                          Alterar foto
                        </v-btn>
                      </div>
                    </div>
                    <div v-else class="text-center mb-4">
                      <v-avatar size="120" class="elevation-2 grey lighten-3">
                        <v-icon size="64" color="grey darken-2">mdi-account</v-icon>
                      </v-avatar>
                      <div class="mt-2">
                        <v-btn small text color="primary" @click="dialogoCamera = true">
                          <v-icon small left>mdi-camera</v-icon>
                          Adicionar foto*
                        </v-btn>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="10">
                    <v-text-field
                      label="CPF*"
                      outlined
                      dense
                      v-model="consumidor.cpf"
                      v-validate="'required|cpf'"
                      :error="errors.has('cpf')"
                      :error-messages="errors.collect('cpf')"
                      data-vv-name="cpf"
                      type="tel"
                      v-mask="'###.###.###-##'"
                      color="#01579B"
                      required
                      prepend-inner-icon="mdi-card-account-details-outline"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="10">
                    <v-text-field
                      label="Nome e sobrenome*"
                      outlined
                      dense
                      v-model="consumidor.nome"
                      color="#01579B"
                      prepend-inner-icon="mdi-account"
                      v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }"
                      name="regex"
                      :error-messages="errors.collect('nome')"
                      data-vv-name="nome"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="10">
                    <v-text-field
                      label="WhatsApp com DDD*"
                      outlined
                      dense
                      v-model="consumidor.whatsApp"
                      v-mask="'(##) #####-####'"
                      persistent-hint
                      hint="Nossas notificações serão enviadas para o número informado"
                      type="tel"
                      color="#01579B"
                      prepend-inner-icon="mdi-phone"
                      v-validate="'required|min:15'"
                      :error-messages="errors.collect('telefone')"
                      data-vv-name="telefone"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="10">
                    <v-text-field
                      v-model="consumidor.dataNascimento"
                      label="Data de nascimento"
                      v-mask="'##/##/####'"
                      prepend-inner-icon="mdi-calendar"
                      outlined
                      dense
                      color="#01579B"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="10">
                    <v-text-field
                      v-model="consumidor.turma"
                      label="Turma"
                      prepend-inner-icon="mdi-account-group"
                      outlined
                      dense
                      color="#01579B"
                      class="mb-1"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="10">
                    <v-select
                      v-model="consumidor.turno"
                      label="Turno"
                      prepend-inner-icon="mdi-account-group"
                      outlined
                      dense
                      color="#01579B"
                      class="mb-1"
                      :items="['Manhã', 'Tarde']"
                    ></v-select>
                  </v-col>

                  <v-col cols="10">
                    <v-text-field
                      v-model="consumidor.responsavel"
                      label="Responsável"
                      prepend-inner-icon="mdi-account-supervisor"
                      outlined
                      dense
                      color="#01579B"
                      class="mb-1"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="10">
                    <v-btn
                      block
                      depressed
                      color="#01579B"
                      dark
                      @click="cadastrarConsumidor"
                      >
                        Cadastrar
                      </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-else style="text-align: center;">
                <v-icon size="100" color="orange">mdi-alert</v-icon>
                <h3>Problema ao carregar dados</h3>
              </v-card-text>
            </v-card>
          </v-row>
          <br />
        </v-container>

        <v-dialog v-model="dialogoCadastroEfetuado" persistent max-width="500px">
          <v-card>
            <v-card-title>
              <v-icon left color="green">mdi-check-circle</v-icon>
              Cadastro efetuado!
            </v-card-title>
            <v-card-text style="text-align: justify;">
              <h3>Seu cadastro está pronto! Clique no botão abaixo e utilize as seguintes informações para acessá-lo:</h3>
              <br>
              <h3>Matrícula: {{ consumidor.matricula }}</h3>
              <h3>Senha: {{ consumidor.senha }}</h3>
              <br>
              <h4>Também enviamos um WhatsApp para o número informado com as instruções de acesso.</h4>
            </v-card-text>
            <v-card-actions>
              <v-btn block depressed color="#474d55" dark @click="irParaCartao">Acessar agora</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoCamera" max-width="500px">
          <v-card>
            <v-card-title style="padding: 5px 15px 5px 15px">
              Câmera
              <v-spacer></v-spacer>
              <v-btn @click="dialogoCamera = false" icon>
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="padding: 0px 7px 0px 7px">
              <v-alert type="info" dense text outlined>Capture ou selecione uma foto com rosto visível e claro.</v-alert>
            </v-card-text>
            <v-card-text style="padding: 0px 7px 0px 7px">
              <CameraView
                ref="camera"
                :ativo="dialogoCamera"
                @cameras-detectadas="totalCameras = $event"
              />
              <div class="d-flex justify-center align-center pa-3">
                <div class="text-center mx-4" v-if="totalCameras > 1">
                  <v-btn
                    @click="$refs.camera.alternarCamera()"
                    fab
                    color="primary"
                    depressed
                  >
                    <v-icon large>mdi-camera-flip</v-icon>
                  </v-btn>
                  <div class="caption">Alternar</div>
                </div>
                <div class="text-center mx-4">
                  <v-btn @click="capturarFoto" depressed fab color="primary" class="mb-1">
                    <v-icon large>mdi-camera-iris</v-icon>
                  </v-btn>
                  <div class="caption">Capturar</div>
                </div>
                <div class="text-center mx-4">
                  <file-upload
                    class="d-inline-block"
                    input-id="foto-upload"
                    extensions="png,gif,jpeg,jpg"
                    accept="image/png,image/gif,image/jpeg,image/jpg"
                    v-model="files"
                    @input-filter="inputFilter"
                    @input-file="inputFile"
                  >
                    <v-btn fab outlined color="primary">
                      <v-icon large>mdi-file-upload</v-icon>
                    </v-btn>
                  </file-upload>
                  <div class="caption">Galeria</div>
                </div>
                <p id="foto" value="" hidden></p>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>

    <Snackbar ref="chamaSnackbar" />

    <loading :active.sync="isLoading" :can-cancel="false" color="#474d55" :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { baseApiUrl } from "@/global";
import Snackbar from "../../componentes/snackbar.vue";
import { mapState } from "vuex";
import axios from "axios";
// import CpfValidate from "../../componentes/validators/rules/cpf";
import { v4 as uuidv4 } from "uuid";
import FileUpload from 'vue-upload-component'
import CameraView from '../../componentes/CameraView.vue'

export default {
  components: { Snackbar, Loading, FileUpload, CameraView, },
  name: "Auth",
  computed: mapState({
    usuarioLogado: (state) => state.isMenuVisible,
  }),
  data: function () {
    return {
      fullPage: true,
      isLoading: false,
      dialogoCadastroEfetuado: false,
      dialogoCamera: false,
      exibeFormulario: true,
      empresa: {
        logoUrl: '',
        id: '',
      },
      consumidor: {
        hashBase64: "",
        cpf: "",
        nome: "",
        dataNascimento: "",
        turma: "",
        turno: "",
        responsavel: "",
        whatsApp: "",
        matricula: "",
        qrCode: "",
      },
      urlCartaoConsumo: "",
      files: [],
      totalCameras: 1,
      dictionary: {
        custom: {
          nome: {
            required: () => "Informe o nome",
            regex: () => 'Informe nome e sobrenome'
          },
          cpf: {
            required: () => "Informe o CPF",
            cpf: () => "CPF inválido",
          },
          telefone: {
            required: () => "Informe o WhatsApp",
            min: () => "O WhatsApp deve ter 11 dígitos"
          },
          foto: {
            required: () => "Adicione uma foto",
          },
        }
      },
    };
  },
  
  watch: {
    async dialogoCamera(val) {
      if (val == true) {
        //
      } else {
        //
      }
    }
  },

  mounted() {
    this.$validator.localize('pt', this.dictionary)
    this.pegaParametrosUrl()
  },

  beforeDestroy() {
    //
  },

  methods: {
    async pegaParametrosUrl() {
      this.isLoading = true
      var params = window.location.search.substring(1).split('&');

      if (params[0] != '') {
        var paramArray = {};                        // Criar objeto que vai conter os parametros

        for (var i = 0; i < params.length; i++) {   // Passar por todos os parametros
          var param = params[i].split('=');         // Dividir os parametros chave e valor
          paramArray[param[0]] = param[1];          // Adicionar ao objeto criado antes
        }

        if (paramArray['s']) {
          this.consultaEmpresa(paramArray['s'])
        }
      }
      else {
        this.exibeFormulario = false
      }

      this.isLoading = false
    },

    async consultaEmpresa(subdominio) {
      await axios.post(baseApiUrl + 'Empresas/porSubdominio', {"dominio": subdominio})
      .then(response => {
        if (response.data) {
          this.empresa = response.data
          this.empresa.subdominio = subdominio
        }
      })
      .catch(error => {
        this.exibeFormulario = false
        this.$refs.chamaSnackbar.snack("#FF0000", error.response.data.error.message, "ATENÇÃO")
      })
    },

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },

    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        let vm = this
        var reader = new FileReader()
        var file = this.files[0]

        //salva a base64 na variável
        reader.onloadend = function() {
          document.getElementById('foto').value = reader.result
          vm.consumidor.hashBase64 = reader.result
          vm.dialogoCamera = false
        };

        //Gera base64
        reader.readAsDataURL(file.file);
      }
    },

    async capturarFoto() {
      this.consumidor.hashBase64 = await this.$refs.camera.capturar()
      this.dialogoCamera = false
    },

    async cadastrarConsumidor() {
      let vm = this;
      let formularioValido = await this.$validator.validateAll()

      if (!formularioValido) {
        return;
      }

      this.isLoading = true;
      this.consumidor.qrCode = uuidv4();
      this.consumidor.matricula = this.consumidor.cpf.replace(/\D/g, '')
      this.consumidor.empresaId = this.empresa.id
      this.consumidor.senha = Math.floor(1000 + Math.random() * 9000).toString()
      this.consumidor.turma = this.consumidor.turma + ' - ' + this.consumidor.turno
      delete this.consumidor.turno

      await axios.post(baseApiUrl + "Consumidores/novoConsumidorComCartaoFacial", this.consumidor)
      .then((response) => {
        if (response.data) {
          this.dialogoCadastroEfetuado = true;
        }
      })
      .catch(error => {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Problema ao cadastrar consumidor. " + error.response.data.error.message, "ATENÇÃO");
      })

      this.isLoading = false;
    },

    irParaCartao() {
      this.$router.push({ path: '/', query: { s: this.empresa.subdominio } })
    },
  },
};
</script>

<style scoped>
/* LOGIN */
.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login100 {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: linear-gradient(to right, #f5f5f5, #f5f5f5);
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}
.header {
  color: #5b6b4f;
}

/* Highlight */
.highlight {
  color: #f58742;
}

/* Buttons */
.button {
  background-color: #d44333;
  border: none;
  color: #f5e3c7;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
}

.button:hover {
  background-color: #a56732;
}

/* Banners */
.banner {
  background-color: #6d8b55;
  color: #f5e3c7;
}

/* Footers */
.footer {
  background-color: #e0a048;
  color: #f5e3c7;
}

.wrap-login100 {
  width: 400px;
  overflow: hidden;
  background: transparent;
}

/* [ Form ] */
.login100-form {
  max-width: 90%;
  border-radius: 15px;
  background-color: #bdd2d3;
  opacity: 0.9;
  padding-top: 15px;
  padding-bottom: 15px;
}

.login100-form-title {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.linkapp {
  text-decoration: none;
  color: white;
  font-size: 9px;
}
</style>
